/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ConvertAuthorizedAmountRequest } from '../models/ConvertAuthorizedAmountRequest';
import type { ConvertAuthorizedAmountResponse } from '../models/ConvertAuthorizedAmountResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class CurrencyExchangeRateControllerV2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param currencyCode
     * @param date
     * @returns number
     * @throws ApiError
     */
    public currencyExchangeRateControllerV2GetExchangeRate(
        currencyCode: string,
        date?: string,
    ): Observable<number | null> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/currency-exchange-rates/{currencyCode}',
            path: {
                'currencyCode': currencyCode,
            },
            query: {
                'date': date,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ConvertAuthorizedAmountResponse
     * @throws ApiError
     */
    public currencyExchangeRateControllerV2ConvertAuthorizedAmount(
        requestBody: ConvertAuthorizedAmountRequest,
    ): Observable<ConvertAuthorizedAmountResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/currency-exchange-rates/convert',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
